import React, { useMemo } from 'react';
import { sliceStringIntoLines } from 'apps/sigma2-ui/src/lib/charts/slice-string';

export const MultiLineChartAxisLegend = ({
  legendText,
  lineLength,
}: {
  legendText: string;
  lineLength: number;
}) => {
  // Split text by spaces to try and fit within the given line length
  const lines = useMemo(
    () => sliceStringIntoLines(legendText, lineLength),
    [legendText, lineLength],
  );

  return (
    <>
      {lines.map((line, index) => (
        <tspan key={index} x="0" dy={`${index === 0 ? 0 : 1.2}em`}>
          {line}
        </tspan>
      ))}
    </>
  );
};
